import {ImmunizationHepBViewNew} from "./ImmunizationHepBViewNew";

export default ImmunizationHepBViewNew;
